import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EmailConfig } from 'projects/qcloud-models/email/email-config.model';
import { Observable } from 'rxjs';
import { AuthService } from './auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class EmailConfigService {

  appBase: string;

  constructor(private http: HttpClient, private authService: AuthService) { }

  public setAppBase(appBase: string) {
    this.appBase = appBase;
  }

  getEmailConfig() : Observable<EmailConfig> {
    return this.http.get<EmailConfig>(
      `${this.appBase}api/${this.authService.getSystemId()}/${this.authService.getLocationId()}/smtp`);
  }

  setEmailConfig(emailConfig: EmailConfig) {
    return this.http.post(
      `${this.appBase}api/${this.authService.getSystemId()}/${this.authService.getLocationId()}/smtp`, emailConfig);
  }

  sendTestEmail(mailTo: string) {
    return this.http.post(
      `${this.appBase}api/${this.authService.getSystemId()}/${this.authService.getLocationId()}/smtp/test/${mailTo}`, {});
  }
}
